export default __webpack_public_path__ + "static/media/printhover.c10389ca.svg";